import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58499476")

_pushScopeId("data-v-58499476")
const _hoisted_1 = { id: "gifContrSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "GIF Component ID", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Pause GIF", -1)
const _hoisted_6 = { class: "settings-row" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Reset GIF", -1)
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.action.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", 
        _ctx.components[_ctx.action.targetId] &&
        _ctx.components[_ctx.action.targetId].displayName == 'GIF'
          ? ''
          : 'red-text'
      ]
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.targetId]
          ? " NOT FOUND!"
          : _ctx.components[_ctx.action.targetId].displayName != "GIF"
          ? " is not a GIF"
          : ": " + _ctx.components[_ctx.action.targetId].name), 3),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.action.pause = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.action.pause]
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.action.reset = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.action.reset]
      ])
    ]),
    _createVNode("p", _hoisted_8, [
      _createTextVNode(" Action will " + _toDisplayString(_ctx.action.pause ? "" : "un") + "pause the GIF ", 1 /* TEXT */),
      (_ctx.action.reset)
        ? (_openBlock(), _createBlock("span", _hoisted_9, "and reset it to its first frame"))
        : _createCommentVNode("", true)
    ])
  ]))
})